import PostForm from "./PostForm.presenter";
export default PostForm;
